import {createBrowserRouter} from "react-router-dom"
import Home from "../pages/Home"
import Note from "../pages/Note"
import Link from "../pages/Link"
import NotFound from "../pages/NotFound"

const router = createBrowserRouter([
  {
    path:"/",
    element:<Home />
  },
  {
    path: "/note",
    element: <Note />
  },
  {
    path: "/link",
    element: <Link />
  },
  {
    path: "/*",
    element: <NotFound />
  },
])

export { router }